export default __webpack_public_path__ + "static/media/3.2f091b7a.jpg";